module.exports = __webpack_public_path__ + "img/LUCKY_LIONS_05.b59f4c53.jpg";